import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import type { SignOutAdminOptions } from '@/lib/sign-out';

export interface AuthContextValue {
  session: Session | null;
  /** Shorthand for `session?.user ?? null`. */
  user: User | null;
  isLoading: boolean;
  error: Error | null;
  /** Global by default; the idle timeout passes `{ scope: 'local' }`. */
  signOut: (options?: SignOutAdminOptions) => Promise<void>;
}

/**
 * The one auth state for the whole app, owned by `AuthProvider`. `null` means
 * no provider is mounted — `useAuth` throws rather than silently reporting
 * "signed out".
 */
export const AuthContext = createContext<AuthContextValue | null>(null);
